export const AllEvents = [
    {
        title: 'Event 1',
        postDate: '2022-09-01',
        description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.',
        donation: false,
    },
    {
        title: 'Event 2',
        postDate: '2022-09-02',
        description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. lfjadkj afadfjklafd  dfjakjfd  fdakjfda  afdkljfsdal  fjaklfjadls  dfaklja  falkdfjalfd  dafkljaslkf aadsjlkjadf a',
        donation: true,
    },
    {
        title: 'Event 3',
        postDate: '2022-09-03',
        description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.',
        donation: true,
    },
    {
        title: 'Event 4',
        postDate: '2022-09-04',
        description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.',
        donation: true,
    },
    {
        title: 'Event 5',
        postDate: '2022-09-05',
        description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.',
        donation: false,
    },
    {
        title: 'Event 6',
        postDate: '2022-09-06',
        description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.',
        donation: true,
    },
    {
        title: 'Event 7',
        postDate: '2022-09-07',
        description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.',
        donation: false,
    },
    {
        title: 'Event 8',
        postDate: '2022-09-08',
        description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.',
        donation: true,
    },
    {
        title: 'Event 9',
        postDate: '2022-09-09',
        description: 'lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi.',
        donation: false,
    }
]